import { PromptTextField, type PromptTextFieldProps } from './PromptTextField';
import { EnhancePromptButton } from './EnhancePromptButton';
import { SuggestionPanel } from './SuggestionPanel';
import type { PromptSuggestion } from './usePromptSuggestion';

export interface PromptInputProps extends Omit<PromptTextFieldProps, 'mode'> {
    suggestion: PromptSuggestion;
}

export function PromptInput({
    suggestion,
    ...textFieldProps
}: PromptInputProps) {
    const showSuggestionPanel =
        suggestion.isLoadingSuggestion || !!suggestion.suggestedText;

    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center">
                <div className="min-w-0 flex-1 pr-4">
                    <PromptTextField {...textFieldProps} />
                </div>
                <div className="shrink-0">
                    <EnhancePromptButton
                        onClick={suggestion.requestSuggestion}
                        loading={suggestion.isLoadingSuggestion}
                        visible={
                            suggestion.canRequestSuggestion ||
                            suggestion.isLoadingSuggestion
                        }
                    />
                </div>
            </div>
            {showSuggestionPanel && (
                <SuggestionPanel
                    isLoading={suggestion.isLoadingSuggestion}
                    text={suggestion.suggestedText}
                    onAccept={suggestion.acceptSuggestion}
                    onDecline={suggestion.declineSuggestion}
                />
            )}
        </div>
    );
}
